export default __webpack_public_path__ + "static/media/logo.c02d8ded.png";